export default "__VITE_ASSET__Lxxvu$r0__"